import React from "react";
import { neturalBlack, netural400, primaryOrange } from "../../../constants/color";

const TransferPagination = ({
  currentPage,
  totalCount,
  pageSize = 20,
  hasMore,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalCount / pageSize);
  const startItem = totalCount === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalCount);

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (hasMore) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: "20px",
        padding: "16px",
        border: "1px solid #DADADA",
        borderRadius: "12px",
        backgroundColor: "#ffffff",
        flexWrap: "wrap",
        gap: "16px",
      }}
    >
      <div style={{ color: netural400, fontSize: "14px" }}>
        Showing {startItem}–{endItem} of {totalCount}
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <button
          onClick={handlePrevious}
          disabled={currentPage === 1}
          style={{
            padding: "8px 16px",
            borderRadius: "8px",
            border: "1px solid #DADADA",
            backgroundColor: currentPage === 1 ? "#F2F2F2" : "#ffffff",
            color: currentPage === 1 ? "#A6A6A6" : neturalBlack,
            fontSize: "14px",
            cursor: currentPage === 1 ? "not-allowed" : "pointer",
            fontWeight: "500",
          }}
        >
          ← Prev
        </button>

        <span style={{ color: netural400, fontSize: "14px" }}>
          Page {currentPage} of {totalPages || 1}
        </span>

        <button
          onClick={handleNext}
          disabled={!hasMore}
          style={{
            padding: "8px 16px",
            borderRadius: "8px",
            border: "1px solid #DADADA",
            backgroundColor: !hasMore ? "#F2F2F2" : "#ffffff",
            color: !hasMore ? "#A6A6A6" : neturalBlack,
            fontSize: "14px",
            cursor: !hasMore ? "not-allowed" : "pointer",
            fontWeight: "500",
          }}
        >
          Next →
        </button>
      </div>
    </div>
  );
};

export default TransferPagination;
